import { render, staticRenderFns } from "./PelletsCtaWidget.vue?vue&type=template&id=94e623da&scoped=true"
import script from "./PelletsCtaWidget.vue?vue&type=script&lang=ts"
export * from "./PelletsCtaWidget.vue?vue&type=script&lang=ts"
import style0 from "./PelletsCtaWidget.vue?vue&type=style&index=0&id=94e623da&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e623da",
  null
  
)

export default component.exports